<template lang="pug">
.question-list
  app-header.header

  //- パンくずリスト
  ul.breadcrumb
    li
      router-link(to="/") {{ $t('Home') }}
    li
      router-link(to="/master") {{ $t('Master Manage')}}
    li.active
      span {{ $t('Master Service Questions List') }}

  .row.margin-top
    .col-sm-6
      //form
      div
        .form-inline
          .input-group
              input.form-control(type="text", placeholder="評価タイトル", v-model="searchTitle", v-on:keydown.enter="search(false)")
              .input-group-btn
                button.btn.btn-default(v-on:click="search(false)")
                  i.fa.fa-search
    .col-sm-6.text-right
      a.btn.btn-info(v-on:click="goQuestionNew()")
          i.fa.fa-plus
          span {{ $t('New Registration') }}
  div
    div(v-if="searchEnd && questions.length > 0")
      .row.margin-top
        //- 一覧表示
        .table-responsive
          table.table.table-condensed()
            //- 表示ヘッダ
            thead
              tr.info
                th.col-sm-12(colspan="2") 評価タイトル
            tbody
              tr(v-for="(question,index) in questions")
                td
                  a(v-on:click="goQuestionDetail(question.id)") {{ question.attributes.title }}
                td(style="text-align: right;")
                  a(v-on:click="goQuestionEdit(question.id, question.attributes['is-before-notification-start'])").btn.btn-info.btn-sm.margin-right {{ $t('Edit') }}
                  a(v-on:click="questionDelete(question.id, question.attributes['is-use-user-type'])").btn.btn-danger.btn-sm {{ $t('Delete') }}

      //- 更に読み込む
      .row.margin-top(v-if="nextExist")
        .col-xs-12.text-center
          button.btn.btn-default.next-page-search-btn(v-on:click="search(true)")
            i.fa.fa-chevron-down
            =" "
            span {{ $t('Read More') }}

    .row.margin-top(v-if="searchEnd && questions.length == 0")
      .col-xs-12
        .alert.alert-warning
          i.fa.fa-exclamation-triangle
          =" "
          span {{ $t('No Data') }}
</template>
<script>
var utils = require('../utils')
import AppHeader from './AppHeader'

export default {
  name: 'master-service-question-list',
  created () {
    console.log('created')
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      questions: '',
      searchTitle: '',
      searchEnd: false,
      nextExist: false,
      currentPage: 0
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
  },
  components: {
    AppHeader
  },
  methods: {
    search: function (addSearch) {
      let data = {
        search_title: this.searchTitle
      }
      if (addSearch) {
        this.currentPage += 1
        data['current_page'] = this.currentPage
        data['add_search'] = true
      } else {
        this.searchEnd = false
        this.currentPage = 0
      }
      this.$store.dispatch('GET_MASTER_SERVICE_QUESTION_LIST', { data: data })
      .then(res => {
        if (addSearch) {
          this.questions = this.questions.concat(res.questions.data)
        } else {
          this.questions = res.questions.data
          this.searchEnd = true
        }
        this.nextExist = res.next_exist
      })
      .catch(err => console.log(err))
    },
    goQuestionNew: function () {
      this.$router.push({ path: '/master/service_questions/new' })
    },
    goQuestionEdit: function (questionId, isBeforeNotificationStart) {
      if (isBeforeNotificationStart === 1) {
        window.alert('この評価は未公開の接客評価の評価項目に設定されています。\n編集を行うと評価項目が変わります。')
      }
      this.$router.push({ path: '/master/service_questions/' + questionId + '/edit' })
    },
    goQuestionDetail: function (questionId) {
      this.$router.push({ path: '/master/service_questions/' + questionId })
    },
    questionDelete: function (questionId, isUseUsertype) {
      if (isUseUsertype === 1) {
        window.alert('この評価は役職マスターに設定されています。\n削除を行う場合は、本社のシステム担当者宛てに連絡して下さい。')
      } else {
        if (window.confirm(this.$t('Delete Confirm'))) {
          this.$store.dispatch('MASTER_SERVICE_QUESTION_DELETE', {
            data: {
              id: questionId
            }
          })
          .then(res => {
            this.search()
          })
          .catch(err => console.log(err))
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// MasterServiceQuestionList.vue?4bc902f2